import { notification } from "antd";

notification.config({
  placement: "bottomRight",
  bottom: 50,
  duration: 2,
});
